import { FiMenu } from "react-icons/fi";
import { FaBell } from "react-icons/fa";
import profileImg from "../assets/profile.jpeg";
import { useAuth } from "../context/AuthContext";

const Navbar = ({ setIsOpen }) => {
  const { user } = useAuth();

  return (
    <nav className="bg-white shadow-md px-6 py-3 flex justify-between items-center">
      {/* Left Side - Hamburger + Welcome */}
      <div className="flex items-center gap-4">
        {/* Hamburger only on mobile */}
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="p-2 rounded-lg hover:bg-gray-100 text-gray-700 md:hidden"
        >
          <FiMenu size={22} />
        </button>
        <h2 className="text-lg font-semibold">Welcome, {user.name}</h2>
      </div>

      {/* Right Side - Profile + Notification */}
      <div className="flex items-center space-x-6">
        <FaBell className="text-gray-600 text-xl cursor-pointer hover:text-gray-800" />
        <img
          src={profileImg}
          alt="profile"
          className="w-10 h-10 rounded-full border object-cover"
        />
      </div>
    </nav>
  );
};

export default Navbar;
